<template>
	<!-- (Login Link) Verification page -->
	<div class="auth-fluid">
		<div class="auth-fluid-form-box">
			<div class="align-items-center d-flex h-100">
				<div class="card-body">
					<div class="auth-brand text-center text-lg-left">
						<a href="/">
							<span>
								<img
									src="@/assets/images/logo.svg"
									alt="Lalamove logo"
									height="36"
								/>
							</span>
						</a>
					</div>

					<!-- If has API error -->
					<template v-if="apiError">
						<div class="text-center w-75 m-auto">
							<h4 class="mt-0">
								{{ $t('PORTAL.Verification.heading') }}
							</h4>
						</div>

						<b-alert
							v-model="hasApiError"
							variant="danger"
							dismissible
						>
							<div>{{ apiError && apiError.message }}</div>
							<div
								v-if="apiError && apiError.requestId"
								class="font-10 mt-1"
							>
								Request ID: {{ apiError.requestId }}
							</div>
						</b-alert>

						<router-link
							tag="a"
							class="btn btn-primary btn-block mt-3"
							to="/login"
						>
							<i class="mdi mdi-reply" />
							{{
								$t('PORTAL.Verification.button_return_to_login')
							}}
						</router-link>
					</template>

					<!-- If link verification is in progress -->
					<template v-else-if="!failed">
						<div class="text-center w-75 m-auto">
							<h4 class="mt-0">
								{{ $t('PORTAL.Verification.heading') }}
							</h4>
							<p class="text-muted mb-4">
								{{ $t('PORTAL.Verification.text_verifying') }}
							</p>
						</div>

						<div class="text-center m-auto">
							<div
								class="spinner-border avatar-lg text-primary"
								role="status"
							/>
						</div>
					</template>

					<!-- If link verification returns invalid -->
					<template v-else>
						<div class="text-center">
							<h1 class="text-error mt-4">
								<i class="mdi mdi-link-variant-remove" />
							</h1>
							<h4 class="text-uppercase text-danger mt-3">
								{{ $t('PORTAL.Verification.heading_invalid') }}
							</h4>
							<p class="text-muted mt-3">
								{{ $t('PORTAL.Verification.text_invalid') }}
							</p>

							<router-link
								tag="a"
								class="btn btn-primary btn-block mt-3"
								to="/login"
							>
								<i class="mdi mdi-reply" />
								{{
									$t(
										'PORTAL.Verification.button_return_to_login'
									)
								}}
							</router-link>
						</div>
					</template>

					<footer class="footer footer-alt">
						<p v-if="appEnv !== 'prd'" class="text-muted">
							{{ appEnv.toUpperCase() }}
						</p>
						<p class="text-muted">
							{{ new Date().getFullYear() }} © Lalamove+
						</p>
					</footer>
				</div>
			</div>
		</div>

		<div class="auth-fluid-right text-center" />
	</div>
</template>

<script>
import { authMethods } from '@/store/helpers'
import { reloadPageOnBaseURLChange } from '@/api/axiosApiClient'

const initState = () => ({
	hasApiError: false,
	apiError: null,
	failed: false, // Invalid link.
	appEnv: VUE_APP_ENV
})

const { VUE_APP_ENV } = process.env

export default {
	page: {
		title: `${
			VUE_APP_ENV !== 'prd' ? VUE_APP_ENV.toUpperCase() : ''
		} Verification`,
		meta: [
			{ name: 'description', content: `Log in to Lalamove+ Web Portal` }
		]
	},
	data() {
		return initState()
	},
	async created() {
		// Submits login ID & code for verification.
		try {
			const { id, code, r } = this.$route.query
			await this.verifyLoginLink({ id, code })
			// Redirect to the originally requested page (for future), or to the home page (for now):
			await this.$router.push(
				this.$route.query.redirectFrom || { name: 'Home' }
			)
			reloadPageOnBaseURLChange(r)
		} catch (error) {
			if (error.isApiError) {
				this.apiError = error
				this.hasApiError = true
			} else {
				this.failed = true
			}
		}
	},
	methods: {
		...authMethods
	}
}
</script>
